import React from "react";
import { Container, Row, Col, Card, Badge } from "react-bootstrap";
import AppNavbar from "../../../components/common/AppNavbar";

const UKImmigration2026 = () => {
  return (
    <>
      <AppNavbar />
      <div style={{ background: "#f4f7fb" }}>
        {/* HERO SECTION */}
        <div
          style={{
            background: "linear-gradient(135deg, #0f2027, #203a43, #2c5364)",
            color: "white",
            padding: "60px 0",
          }}
        >
          <Container>
            <Badge bg="light" text="dark" className="mb-3">
              February 2026 UK Immigration Reform
            </Badge>
            <h1 className="fw-bold">
              UK’s 2026 Immigration Overhaul to Hit Indian/Bharat Workers and
              Students Hardest
            </h1>
            <p className="lead mt-3" style={{ maxWidth: "900px" }}>
              Higher salary thresholds, tougher English requirements, longer
              settlement timelines, and stricter digital border controls are
              reshaping the UK immigration landscape.
            </p>
          </Container>
        </div>

        <section class="uk-immigration-2026">
          <div class="container py-5">
            <h2>
              UK Immigration Reforms 2026 – Key Changes for Indian/Bharat
              Nationals
            </h2>

            <p>
              For Indian/Bharat nationals, one of the UK’s largest migrant
              groups, the 2026 reforms significantly raise costs, increase
              competitiveness, and slow down pathways to permanent residency.
              Legal analysts confirm the system is shifting from a traditional
              time-based model to one driven by skills, earnings, and measurable
              contribution.
            </p>

            <hr />

            <h3>New Strict “Suitability” Framework</h3>

            <p>
              The UK is introducing a standardized and stricter suitability test
              across all visa routes.
            </p>

            <ul>
              <li>NHS debt may trigger refusal.</li>
              <li>
                Tax arrears or unresolved HMRC issues can affect applications.
              </li>
              <li>Past immigration breaches carry heavier penalties.</li>
              <li>
                Minor criminal convictions may result in refusal with less
                discretion.
              </li>
              <li>
                Higher “good character” standards apply across categories.
              </li>
            </ul>

            <hr />

            <h3>
              Increased Salary Thresholds & Employer Costs (Ongoing Into 2026)
            </h3>

            <ul>
              <li>
                Skilled Worker visa salary requirements: £38,700–£41,700+
                depending on role.
              </li>
              <li>
                Higher Immigration Skills Charge for sponsoring employers.
              </li>
              <li>Temporary Shortage List (TSL) expires December 31, 2026.</li>
            </ul>

            <p>
              <strong>Impact on Indian/Bharat Professionals:</strong>
              IT, engineering, healthcare, and finance sectors must now offer
              significantly higher salaries to maintain sponsorship eligibility.
            </p>

            <hr />

            <h3>
              Higher English Language Requirement – Effective January 8, 2026
            </h3>

            <p>
              From January 2026, Skilled Worker, Scale-Up, and High Potential
              Individual (HPI) applicants must demonstrate B2-level English
              proficiency.
            </p>

            <p>
              This replaces the previous B1 requirement and requires stronger
              IELTS, SELT, or equivalent test scores.
            </p>

            <hr />

            <h3>“Earned Settlement” Model – Effective April 2026</h3>

            <p>
              The UK is introducing an “earned settlement” model for Indefinite
              Leave to Remain (ILR).
            </p>

            <ul>
              <li>
                Qualifying period extended from 5 years to 10 years for most
                skilled workers.
              </li>
              <li>
                Settlement depends on earnings, job type, conduct, and community
                contribution.
              </li>
              <li>English requirement raised to B2 (previously B1).</li>
              <li>10-year “long residence” route expected to be abolished.</li>
            </ul>

            <p>
              Indian nationals nearing five years of UK residence are advised to
              apply before April 2026 to avoid transition into the 10-year
              pathway.
            </p>

            <hr />

            <h3>
              Digital Border Controls & Mandatory ETA – Effective February 25,
              2026
            </h3>

            <ul>
              <li>Airlines must verify immigration status before boarding.</li>
              <li>
                Electronic Travel Authorization (ETA) required for eligible
                travelers.
              </li>
              <li>Strict “no permission, no travel” enforcement.</li>
              <li>
                Dual nationals and exempt categories must show digital
                clearance.
              </li>
            </ul>

            <hr />

            <h3>Student Route Changes</h3>

            <ul>
              <li>
                Graduate Route shortened to 18 months (from January 2027).
              </li>
              <li>
                Financial maintenance requirements increased:
                <ul>
                  <li>£1,171/month (outside London)</li>
                  <li>£1,529/month (in London)</li>
                </ul>
              </li>
            </ul>

            <hr />

            <h3>Summary</h3>

            <p>
              The UK’s 2026 immigration reforms create a more demanding,
              costlier, and slower immigration environment — particularly for
              Indian/Bharat nationals.
            </p>

            <p>
              Higher salary requirements, tougher English standards, longer
              settlement timelines, and stricter digital border controls signal
              a system designed for fewer, higher-skilled, and higher-earning
              migrants.
            </p>

            <p>
              Early planning, strong English proficiency, and financial
              preparedness are now essential for prospective workers, students,
              and long-term residents.
            </p>
          </div>
        </section>
      </div>
    </>
  );
};

export default UKImmigration2026;
